import React, { useEffect } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import firebase from 'firebase/app';
import 'firebase/messaging';
import { useAuthContext } from './hooks/useAuthContext'
import AuthenticatedRouteWrapper from './context/AuthenticatedRouteWrapper.js';

// page components
import Home from './pages/Home'
import WeAreLookingForForm from './pages/WeAreLookingFor/WeAreLookingForForm.js';
import About from './pages/About'
import Services from './pages/Services.js'
import Contact from './pages/Contact'
import Feedback from './pages/Feedback.js'

import Login from './pages/Login/Login'
import Signup from './pages/Signup/Signup.js'
import AfroForm from './components/Accounts/Afroform.jsx';
import InvitationComponent from './components/Accounts/Afholders/InvitationComponent.js'
import AfholderRequest from './components/Accounts/Afholders/BecomeAnAfholder.js';
import UserProfile from './components/Accounts/UserProfiles/UserProfile.js';
import BoameoooServices from './components/Accounts/BoameoooServices/BoameoooServices.js';

import WealthForm from './pages/WealthValues/WealthForm.jsx';

import JobTypes from './pages/WorksAndJobs/JobTypes.js';
import PostJobForm from './pages/WorksAndJobs/PostJobs/PostJobForm.js';
import LocalServices from './pages/WorksAndJobs/PostJobs/LocalServices.js';
import ProfessionalCareers from './pages/WorksAndJobs/PostJobs/ProfessionalCareers.js';
import WorksAndJobsLanding from './pages/WorksAndJobs/WorksAndJobsLanding.js';
import PostedJobDetail from './pages/WorksAndJobs/PostJobs/PostedJobDetail.js';
import RequestedWorkDetail from './pages/WorksAndJobs/PostJobs/RequestedWorkDetail.js';

import GlobalAfricaExchangeLanding from './pages/GlobalAfricaExchange/GlobalAfricaExchangeLanding.js';
import TradeProducts from './pages/GlobalAfricaExchange/PostExport/TradeProducts.js';
import TradeCategories from './pages/GlobalAfricaExchange/TradeCategories/TradeCategories.js';
import TradeCategoriesManager from './pages/GlobalAfricaExchange/TradeCategoriesManager/TradeCategoriesManager.js';

import PostExportOfferForm from './pages/GlobalAfricaExchange/PostExport/PostExportOfferForm.js';

import ImportForm from './pages/GlobalAfricaExchange/PostImport/ImportForm.js'
import ExportDetailPage from './pages/GlobalAfricaExchange/PostExport/ExportDetailPage.js';
import ImportDetailPage from './pages/GlobalAfricaExchange/PostImport/ImportDetailPage.js';

import Pictures from './pages/Pictures/Pictures'

import FlutterwavePayments from './components/Payments/FlutterwavePayments.js';

import BookChapters from './pages/AnPbooks/BookChapters';
import Dchapters from './pages/AnPbooks/Dchapters';
import AddBook from './pages/AnPbooks/AddBook/AddBook';
import AddChapterComponent from './pages/AnPbooks/AddBook/AddChapterComponent';
import DeleteBook from './pages/AnPbooks/DeleteBook/DeleteBook';
import BookUpdate from './pages/AnPbooks/BookUpdate';
import ChapterContentUpdate from './pages/AnPbooks/ChapterContentUpdate';
import HomeBooks from './pages/AnPbooks/HomeBooks/HomeBooks';
import EditBook from './pages/AnPbooks/UpdateBook/EditBook'
import UpdateBook from './pages/AnPbooks/UpdateBook/UpdateBook'
import UpdateBook2 from './pages/AnPbooks/UpdateBook/UpdateBook2'

import DeliveryHome from './pages/Deliveries/DeliveryHome';
import DeliveryForm from './pages/Deliveries/Packages/DeliveryForm.js';
import OrderSummary from './pages/Deliveries/OrderSummary.js';
import Sendings from './pages/Deliveries/Sendings';
import Receivals from './pages/Deliveries/Receivals/Receivals.js';
import DeliveryHelp from './pages/Deliveries/DeliveryHelp';
import MyOrders from './pages/Deliveries/MyOrders';
import Tracking from './pages/Deliveries/Tracking';
import Pickups from './pages/Deliveries/Pickups';
import DeliveryMessages from './pages/Deliveries/DeliveryMessages';

import DeliveryPartnerOnboarding from './pages/DeliveryPartners/DeliveryPartnerOnboarding.js'
import EditPartnerProfile from './components/Dashboard/EditPartnerProfile.js'
import AddressManager from './components/ShippingAddress/AddressManager.js';
import JobTypesManager from './pages/WorksAndJobs/JobTypesManager.js'


import CompletedCheckout from './components/ShoppingCart/CompletedCheckout'
import SerializedCheckout from './components/ShoppingCart/SerializedCheckout'
import PropertuPage from './pages/Propertu/Home/PropertuPage';
import SearchResultsPage from './pages/Propertu/Home/SearchResultsPage';
import PropertyInputForm from './pages/Propertu/Home/PropertyInputForm';
import PropertyPostingOptions from './pages/Propertu/Home/PropertyPostingOptions';
import AgentList from './pages/Propertu/Home/AgentList';
import AdvertForm from './components/Propertu/AdvertFeatures/AdvertArea/AdvertForm';
import AgentPage from './pages/Propertu/Home/AgentPage';
import AgentRegistrationForm from './pages/Propertu/Home/AgentRegistrationForm';
import Rentals from './pages/Propertu/Rentals/Rentals';


import RoleManagement from './pages/RoleManagement/RoleManagement';
import AdminDashboard from './components/Dashboard/AdminDashboard/AdminDashboard';
import BookList from './pages/AnPbooks/BookList';
import BookItem from './pages/AnPbooks/BookItem';

import Dashboard from './components/Dashboard/Dashboard.js';

import Notifications from './components/Notifications/NotificationManagement.js';
import FirestoreData from './firebase/FirestoreData';


import { AddProposalBlank } from './pages/Proposals/screens/AddProposalBlank/AddProposalBlank';
import { ProposalLanding } from './pages/Proposals/screens/ProposalLanding/ProposalLanding.jsx';
import ProposalDetails from './pages/Proposals/screens/ProposalDetails/ProposalDetails.jsx';

import SubmitQuote from './pages/Quotes/SubmitQuote'
import Invoice from './components/Invoices/Invoice'
import { downloadAllExchangeRates } from './components/ExchangeRates/downloadAllExchangeRates';

import './globalStyles.css';
import TestReactSelect from './pages/TestCodes/TestReactSelect';
import AddPackage from './pages/TestCodes/AddPackage';
import ReactDropdown from './pages/TestCodes/ReactDropdown';
import NavDropdownExample from './pages/TestCodes/NavDropdownExample';
import Mouse1 from './pages/TestCodes/Mouse1';

import StripeDocPayment from './components/StripePayments/StripeDocPayment';

import ServicesHomePage from './ecommerce/services/serviceshomepage';

import GoogleGeolocations from './components/Geolocations/Google/GoogleGeolocations.js';

                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  
const PrivateRoute = ({ component: Component, roles, ...rest }) => {
  const { user, role } = useAuthContext()

  return (
    <Route
      {...rest}
      component={(props) => {
        if (!user) {
          return <Redirect to="/login" />
        }
        if (roles && !roles.includes(role)) {
          return <Redirect to="/" />
        }
        return <Component {...props} />
      }}
    />
  )
};
function App() {
  const { authIsReady, user } = useAuthContext()


  useEffect(() => {
    if ('serviceWorker' in navigator && firebase.messaging.isSupported()) {
      // Initialize Firebase Messaging and get the token
      const messaging = firebase.messaging();
      messaging.getToken({ vapidKey: 'BLzZQYm2LKEvccvdDDddGpeuf_pG2GR7UeGbyGr8FVDNyvw7D' })
        .then((currentToken) => {
          if (currentToken) {
            console.log('FCM Token:', currentToken);
            // Handle the token as needed here
          } else {
            console.log('No registration token available. Request permission to generate one.');
          }
        })
        .catch((err) => {
          console.log('An error occurred while retrieving token. ', err);
        });
    }
  }, [authIsReady]);
  

  return (
  <div>
  
    {authIsReady && (
        <BrowserRouter>
          {/* Public Routes */}
          <Route path="/login">
            {user ? <Redirect to="/" /> : <Login />}
          </Route>
          <Route path="/signup">
            {user ? <Redirect to="/" /> : <Signup />}
          </Route>
          {/* Protected Routes */}
          <AuthenticatedRouteWrapper>
            <Switch>
              <Route exact path="/" component={Home} />
              
            
              <Route path="/lookmessageform"><WeAreLookingForForm/></Route>

              <Route path="/afroform"><AfroForm/></Route>
              <Route path="/afholderrequest"><AfholderRequest/></Route>
              <Route path="/invitation"><InvitationComponent/></Route>
              <Route path="/userprofile"><UserProfile/></Route>
              <Route path="/boameoooservices"><BoameoooServices/></Route>

              <Route path="/wealthform"><WealthForm/></Route>

              <Route path="/jobtypes"><JobTypes/></Route>
              <Route path="/jobtypesmanager"><JobTypesManager/></Route>
              <Route path="/worksandjobs"><WorksAndJobsLanding/></Route>
              <Route path="/post-job"><PostJobForm/></Route>
              <Route path="/local-services"><LocalServices/></Route>
              <Route path="/professional-careers"><ProfessionalCareers/></Route>
              <Route path="/posted-job/:jobId" component={PostedJobDetail} />
              <Route path="/requested-work/:workId" component={RequestedWorkDetail} />


              <Route path="/global-africa-exchange"><GlobalAfricaExchangeLanding/></Route>
              <Route path="/trade-products"><TradeProducts/></Route>
              <Route path="/trade-categories"><TradeCategories/></Route>
              <Route path="/trade-categories-manager"><TradeCategoriesManager/></Route>
              <Route path="/post-export"><PostExportOfferForm/></Route>
              <Route path="/post-import"><ImportForm/></Route>
              <Route path="/export-details/:id" component={ExportDetailPage} />
              <Route path="/import-details/:id" component={ImportDetailPage} />
              
              <Route path="/books"><HomeBooks/></Route>
              <Route path="/addbook"><AddBook /></Route>
              <Route path="/addchapter"><AddChapterComponent /></Route>
              <Route path="/editbook"><EditBook /></Route>
              <Route path="/updatebook"><UpdateBook /></Route>
              <Route path="/updatebook2"><UpdateBook2 /></Route>
              <Route path="/bookupdate"><BookUpdate /></Route>
              <Route path="/booklist"><BookList /></Route>
              <Route path="/book/:id"><BookItem /></Route>
              <Route path="/chapters/:id"><BookChapters /></Route>
              <Route path="/dchapters/:id/:index"><Dchapters /></Route>
              <Route path="/chapterupdate"><ChapterContentUpdate /></Route>

              <Route path="/deliveryhome"><DeliveryHome /></Route>
              <Route path="/sendings"><Sendings /></Route>
              <Route path="/order-summary"><OrderSummary /></Route>
              <Route path="/delivery-form"><DeliveryForm /></Route>
              
              <Route path="/receivals"><Receivals /></Route>
              <Route path="/myorders"><MyOrders /></Route>
              <Route path="/deliveryhelp"><DeliveryHelp /></Route>
              <Route path="/tracking/:orderId" component={Tracking} />
              <Route path="/pickups"><Pickups /></Route>
              <Route path="/deliverymessages"><DeliveryMessages /></Route>
              <Route path="/address-manager"><AddressManager /></Route>
              <Route path="/edit-partner-profile" component={EditPartnerProfile} />
              <Route path="/deliveryonboarding"><DeliveryPartnerOnboarding /></Route>
              


              <PrivateRoute path="/addproposal" component={AddProposalBlank} />
              <PrivateRoute path="/proposallanding" component={ProposalLanding} />
              <PrivateRoute path="/proposals/:id" component={ProposalDetails} />

              <Route path="/submitquotes"><SubmitQuote /></Route> 
              <Route path="/checkout/completed" component={CompletedCheckout} />
              <Route path="/serialized-checkout" component={SerializedCheckout} />
              <Route path="/propertu"><PropertuPage /></Route>
              <Route path="/invoice" component={Invoice} />
              <Route path="/rentals"><Rentals /></Route>
              <Route path="/search-results"><SearchResultsPage /></Route>
              <Route path="/propertyform"><PropertyInputForm /></Route>
              <Route path="/propertyposting"><PropertyPostingOptions /></Route>
              <Route path="/agent-list"><AgentList /></Route>
              <Route path="/agentpage/:agentId"><AgentPage /></Route>
              <Route path="/agentregisteration"><AgentRegistrationForm /></Route>
              <Route path="/advertform"><AdvertForm /></Route>

              <Route path="/dashboard"><Dashboard /></Route>
              <Route path="/notifications"><Notifications /></Route>
              
              <Route path="/deletebook"><DeleteBook /></Route>

              <Route path="/testreactselect"><TestReactSelect /></Route>
              <Route path="/addpackage"><AddPackage /></Route>
              <Route path="/rdropdown"><ReactDropdown /></Route>
              <Route path="/mouse"><Mouse1 /></Route>
              
              <Route path="/about"><About /></Route>
              <Route path="/about-us" component={About} />
              <Route path="/services" component={Services} />
              
              <Route path="/contact" component={Contact} />
              <Route path="/feedback" component={Feedback} />
              <Route path="/flutterwavepayments"><FlutterwavePayments /></Route>
              <Route path="/dd"><NavDropdownExample /></Route>
              <Route path="/pictures"><Pictures /></Route>
              <Route path="/firestoredata" component={FirestoreData} />
              <PrivateRoute path="/role-management"><RoleManagement /></PrivateRoute>
              <Route path="/admin" component={AdminDashboard} />
              <Route path="/stripedoccheckout" component={StripeDocPayment} />
              <Route exact path="/services" component={ServicesHomePage} />
              <Route exact path="/geolocations" component={GoogleGeolocations} />
              </Switch>
          </AuthenticatedRouteWrapper>
        </BrowserRouter>
    )}
  </div>

);
  
  }

export default App;


